"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionedForm = exports.SectionType = void 0;
const react_1 = __importDefault(require("react"));
const Section_1 = require("./components/Section");
Object.defineProperty(exports, "SectionType", {
  enumerable: true,
  get: function () {
    return Section_1.SectionType;
  }
});
const SectionedForm = _ref => {
  let sections = _ref.sections,
    submitButton = _ref.submitButton,
    container = _ref.container,
    children = _ref.children;
  return react_1.default.createElement(react_1.default.Fragment, null, sections.map((section, sectionIndex) => react_1.default.createElement(Section_1.Section, Object.assign({
    key: sectionIndex,
    container: container
  }, section))).filter(Boolean), children, submitButton ? submitButton({
    sections
  }) : null);
};
exports.SectionedForm = SectionedForm;
exports.default = exports.SectionedForm;